"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ethSupportsNetwork = ethSupportsNetwork;
exports.ethGetAddress = ethGetAddress;
exports.ethGetPublicKeys = ethGetPublicKeys;
exports.ethSignTx = ethSignTx;
exports.ethSupportsSecureTransfer = ethSupportsSecureTransfer;
exports.ethSupportsNativeShapeShift = ethSupportsNativeShapeShift;
exports.ethSupportsEIP1559 = ethSupportsEIP1559;
exports.ethGetAccountPaths = ethGetAccountPaths;
exports.ethSignMessage = ethSignMessage;
exports.ethSignTypedData = ethSignTypedData;
exports.ethVerifyMessage = ethVerifyMessage;
const common_1 = require("@ethereumjs/common");
const tx_1 = require("@ethereumjs/tx");
const sigUtil = __importStar(require("@metamask/eth-sig-util"));
const core = __importStar(require("@shapeshiftoss/hdwallet-core"));
const ethereumjs_tx_1 = __importDefault(require("ethereumjs-tx"));
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// TODO: fix ts-ignore
const ethereumUtil = __importStar(require("ethereumjs-util"));
const utils_1 = require("ethers/lib/utils");
const utils_2 = require("./utils");
function ethSupportsNetwork(chain_id) {
    return __awaiter(this, void 0, void 0, function* () {
        return chain_id === 1;
    });
}
function ethGetAddress(transport, msg) {
    return __awaiter(this, void 0, void 0, function* () {
        const bip32path = core.addressNListToBIP32(msg.addressNList);
        const res = yield transport.call("Eth", "getAddress", bip32path, !!msg.showDisplay);
        (0, utils_2.handleError)(res, transport, "Unable to obtain ETH address from device.");
        return res.payload.address;
    });
}
// Adapted from https://github.com/LedgerHQ/ledger-wallet-webtool
function ethGetPublicKeys(transport, msg) {
    return __awaiter(this, void 0, void 0, function* () {
        const xpubs = [];
        for (const getPublicKey of msg) {
            const { addressNList, coin } = getPublicKey;
            let { scriptType } = getPublicKey;
            if (!scriptType)
                scriptType = core.BTCInputScriptType.SpendAddress;
            // Only get public keys for ETH account paths
            if (!addressNList.includes(0x80000000 + 44, 0) || !addressNList.includes(0x80000000 + 60, 1)) {
                xpubs.push(null);
                continue;
            }
            const parentBip32path = core.addressNListToBIP32(addressNList.slice(0, -1)).substring(2); // i.e. "44'/0'"
            const bip32path = core.addressNListToBIP32(addressNList).substring(2); // i.e 44'/0'/0'
            const res1 = yield transport.call("Eth", "getAddress", parentBip32path, /* display */ false, /* chain code */ true);
            (0, utils_2.handleError)(res1, transport, "Unable to obtain public key from device.");
            const { payload: { publicKey: parentPublicKeyHex }, } = res1;
            const parentPublicKey = (0, utils_2.compressPublicKey)(Buffer.from(parentPublicKeyHex, "hex"));
            const parentFingerprint = new DataView(ethereumUtil.ripemd160(ethereumUtil.sha256(parentPublicKey), false).buffer).getUint32(0);
            const res2 = yield transport.call("Eth", "getAddress", bip32path, /* display */ false, /* chain code */ true);
            (0, utils_2.handleError)(res2, transport, "Unable to obtain public key from device.");
            const { payload: { publicKey: publicKeyHex, chainCode: chainCodeHex }, } = res2;
            const publicKey = (0, utils_2.compressPublicKey)(Buffer.from(publicKeyHex, "hex"));
            const chainCode = Buffer.from(core.mustBeDefined(chainCodeHex), "hex");
            const coinDetails = utils_2.networksUtil[core.mustBeDefined(core.slip44ByCoin(coin))];
            const childNum = addressNList[addressNList.length - 1];
            const networkMagic = coinDetails.bitcoinjs.bip32.public[scriptType];
            if (networkMagic === undefined)
                throw new Error(`scriptType ${scriptType} not supported`);
            xpubs.push({
                xpub: (0, utils_2.createXpub)(addressNList.length, parentFingerprint, childNum, chainCode, publicKey, networkMagic),
            });
        }
        return xpubs;
    });
}
function ethSignTx(transport, msg) {
    return __awaiter(this, void 0, void 0, function* () {
        const bip32path = core.addressNListToBIP32(msg.addressNList);
        const common = common_1.Common.custom({ chainId: msg.chainId });
        const txParams = {
            to: msg.to,
            value: msg.value,
            data: msg.data,
            chainId: msg.chainId,
            nonce: msg.nonce,
            gasLimit: msg.gasLimit,
            gasPrice: msg.gasPrice,
            v: "0x" + msg.chainId.toString(16).padStart(2, "0"),
            r: "0x00",
            s: "0x00",
        };
        const utx = new ethereumjs_tx_1.default(txParams);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore transport.call is drunk, there *is* a third argument to eth.signTransaction
        // see https://github.com/LedgerHQ/ledgerjs/blob/master/packages/hw-app-eth/README.md#parameters-2
        const res = yield transport.call("Eth", "signTransaction", bip32path, utx.serialize().toString("hex"), null);
        (0, utils_2.handleError)(res, transport, "Could not sign ETH tx with Ledger");
        const { v, r, s } = res.payload;
        const tx = tx_1.Transaction.fromTxData(Object.assign(Object.assign({}, txParams), { v: "0x" + v, r: "0x" + r, s: "0x" + s }), { common });
        return {
            v: parseInt(v, 16),
            r: "0x" + r,
            s: "0x" + s,
            serialized: "0x" + core.toHexString(tx.serialize()),
        };
    });
}
function ethSupportsSecureTransfer() {
    return __awaiter(this, void 0, void 0, function* () {
        return false;
    });
}
function ethSupportsNativeShapeShift() {
    return false;
}
function ethSupportsEIP1559() {
    return false;
}
function ethGetAccountPaths(msg) {
    const slip44 = core.slip44ByCoin(msg.coin);
    if (slip44 === undefined)
        return [];
    return [
        {
            addressNList: [0x80000000 + 44, 0x80000000 + slip44, 0x80000000 + msg.accountIdx, 0, 0],
            hardenedPath: [0x80000000 + 44, 0x80000000 + slip44, 0x80000000 + msg.accountIdx],
            relPath: [0, 0],
            description: "BIP 44: Ledger (Ledger Live)",
        },
        {
            addressNList: [0x80000000 + 44, 0x80000000 + slip44, 0x80000000 + 0, msg.accountIdx],
            hardenedPath: [0x80000000 + 44, 0x80000000 + slip44, 0x80000000 + 0],
            relPath: [msg.accountIdx],
            description: "Non BIP 44: Ledger (legacy, Ledger Chrome App)",
        },
    ];
}
function ethSignMessage(transport, msg) {
    return __awaiter(this, void 0, void 0, function* () {
        const bip32path = core.addressNListToBIP32(msg.addressNList);
        if (!(0, utils_1.isHexString)(msg.message))
            throw new Error("data is not an hex string");
        // Ledger's inner implementation does a Buffer.from(messageHex, "hex").length on our message
        // However, Buffer.from method with the "hex" encoding expects a valid hexadecimal string without the 0x prefix
        // so we need to strip it in case it's present
        const sanitizedMessageHex = msg.message.startsWith("0x") ? msg.message.slice(2) : msg.message;
        const res = yield transport.call("Eth", "signPersonalMessage", bip32path, sanitizedMessageHex);
        (0, utils_2.handleError)(res, transport, "Could not sign ETH message with Ledger");
        let { v } = res.payload;
        const { r, s } = res.payload;
        v = v - 27;
        const vStr = v.toString(16).padStart(2, "0");
        const addressRes = yield transport.call("Eth", "getAddress", bip32path, false);
        (0, utils_2.handleError)(addressRes, transport, "Unable to obtain ETH address from Ledger.");
        return {
            address: addressRes.payload.address,
            signature: "0x" + r + s + vStr,
        };
    });
}
function ethSignTypedData(transport, msg) {
    return __awaiter(this, void 0, void 0, function* () {
        const bip32path = core.addressNListToBIP32(msg.addressNList);
        if (!("EIP712Domain" in msg.typedData.types))
            throw new Error("msg.typedData missing EIP712Domain");
        const res = yield (() => __awaiter(this, void 0, void 0, function* () {
            const _res = yield transport.call("Eth", "signEIP712Message", bip32path, msg.typedData);
            if (_res.success === true)
                return _res;
            const typedData = msg.typedData;
            const { types, primaryType, message } = sigUtil.TypedDataUtils.sanitizeData(typedData);
            const domainSeparatorHex = sigUtil.TypedDataUtils.eip712DomainHash(typedData, sigUtil.SignTypedDataVersion.V4).toString("hex");
            const hashStructMessageHex = sigUtil.TypedDataUtils.hashStruct(primaryType, message, types, sigUtil.SignTypedDataVersion.V4).toString("hex");
            // The old Ledger Nano S (not S+) doesn't support signEIP712Message, so we have to fallback to signEIP712HashedMessage
            // https://github.com/LedgerHQ/ledger-live/blob/1de4de022b4e3abc02fcb823ae6ef1f9a64adba2/libs/ledgerjs/packages/hw-app-eth/README.md#signeip712message
            return transport.call("Eth", "signEIP712HashedMessage", bip32path, domainSeparatorHex, hashStructMessageHex);
        }))();
        (0, utils_2.handleError)(res, transport, "Could not sign typed data with Ledger");
        const { r, s, v } = res.payload;
        const signature = (0, utils_1.joinSignature)({
            r: `0x${r}`,
            s: `0x${s}`,
            v: typeof v === "string" ? parseInt(v, 16) : v,
        });
        const addressRes = yield transport.call("Eth", "getAddress", bip32path, false);
        (0, utils_2.handleError)(addressRes, transport, "Unable to obtain ETH address from Ledger.");
        return {
            address: addressRes.payload.address,
            signature,
        };
    });
}
// Adapted from https://github.com/kvhnuke/etherwallet/blob/2a5bc0db1c65906b14d8c33ce9101788c70d3774/app/scripts/controllers/signMsgCtrl.js#L118
function ethVerifyMessage(msg) {
    return __awaiter(this, void 0, void 0, function* () {
        const sigb = Buffer.from(core.stripHexPrefixAndLower(msg.signature), "hex");
        if (sigb.length !== 65) {
            return false;
        }
        sigb[64] = sigb[64] === 0 || sigb[64] === 1 ? sigb[64] + 27 : sigb[64];
        const buffer = (0, utils_1.isBytes)(msg.message) ? Buffer.from((0, utils_1.arrayify)(msg.message)) : Buffer.from(msg.message);
        const hash = ethereumUtil.hashPersonalMessage(buffer);
        const pubKey = ethereumUtil.ecrecover(hash, sigb[64], sigb.slice(0, 32), sigb.slice(32, 64));
        return core.stripHexPrefixAndLower(msg.address) === ethereumUtil.pubToAddress(pubKey).toString("hex");
    });
}
//# sourceMappingURL=ethereum.js.map